import { render, staticRenderFns } from "./PhaseFinalReward.vue?vue&type=template&id=0b16bffc&"
import script from "./PhaseFinalReward.vue?vue&type=script&lang=js&"
export * from "./PhaseFinalReward.vue?vue&type=script&lang=js&"
import style0 from "./PhaseFinalReward.vue?vue&type=style&index=0&id=0b16bffc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports